import { render } from "./ValidationStats.vue?vue&type=template&id=d6f647c2"
import script from "./ValidationStats.vue?vue&type=script&lang=js"
export * from "./ValidationStats.vue?vue&type=script&lang=js"

import "./ValidationStats.vue?vue&type=style&index=0&id=d6f647c2&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
